
export const GET_UNCATEGORIZED_CATEGORY_ID = `
  query GetUncategorizedCategoryId($companyId: ID!) {
    getUncategorizedCategoryId(companyId: $companyId) {
      success
      message
      data {
        categoryId
        categoryName
        companyId
      }
    }
  }
`;
